import {
    type MaybeRefOrGetter,
    toValue,
    type ComputedRef,
    computed,
    inject,
} from 'vue';
import { preconUserProfilesOptionsInjectionKey } from '../symbols';
import {
    type NormalizedPreconUserProfilesGlobalOptions,
    normalizePreconUserProfilesOptions,
} from '../options';

/**
 * Composable that injects the library options into a component.
 *
 * @param override Override the global option values.
 */
export function usePreconUserProfilesOptions(
    override?: MaybeRefOrGetter<
        Partial<NormalizedPreconUserProfilesGlobalOptions> | null | undefined
    >
): ComputedRef<NormalizedPreconUserProfilesGlobalOptions> {
    // This injects global options from the application into the component that uses this composable.
    const options =
        inject(preconUserProfilesOptionsInjectionKey) ??
        normalizePreconUserProfilesOptions();

    // This merges the options with the override values.
    return computed(() => {
        const o = toValue(override) ?? {};

        return {
            ...options,
            defaultAvatarFallbackLetters:
                o.defaultAvatarFallbackLetters ??
                options.defaultAvatarFallbackLetters,
        };
    });
}
